import 'jquery-migrate'

jQuery.migrateMute = true

